export { default as InsertAnchorDialog } from './components/insert-anchor-dialog';
export { default as InsertLinkToAnchorDialog } from './components/insert-link-to-anchor-dialog';
export { default as InsertLinkDialog } from './components/insert-link-dialog';
export { default as InsertMacrosDialog } from './components/insert-macros-dialog';
export {
  default as InsertResourceDialog,
  getResourcesPath,
  getPicturePath,
  acceptPictures,
  acceptDocuments,
  insertValidationPicture,
  insertValidationDocuments
} from './components/insert-resource-dialog';